export class RowHeights {
  public static readonly planningGrid: Record<string, number> = {
    header: 75,
    headerMobile: 32,
    rowSmall: 32,
    rowMedium: 50,
    rowLarge: 60,
    footer: 42,
    loader: 42 // Ag-grid bug ? if loader and footer heights are different and both are present at the same time, the loading row will be badly positioned
  };
}
